// extracted by mini-css-extract-plugin
export default {"container":"products_container__y22Ni","products":"products_products__ZMf2n","menu":"products_menu__bikrp","list":"products_list__aJV2r","product":"products_product__bMYQV"};